import { Injectable } from '@angular/core';
import { FLContent } from 'ng-flamelink';
import { from, Observable } from 'rxjs';
import { Globals, GlobalTranslation } from '../../models/globals.model';
import { Lang } from '../../models/language.model';
import { HelpersService } from '../../services/helpers/helpers.service';
import { LanguageQuery } from '../language/language.query';
import { GlobalsStore } from './globals.store';

@Injectable({ providedIn: 'root' })
export class GlobalsService {

  constructor(
    private globalsStore: GlobalsStore,
    private content: FLContent,
    private helpers: HelpersService,
    private languageQuery: LanguageQuery,
  ) {
    this.init()
  }

  get currentTranslation$() {
    return new Observable(subscriber => {
      this.languageQuery.select().subscribe(language => {
        const currentTranslation: GlobalTranslation = this.globalsStore.getValue()[language.key]
        subscriber.next(currentTranslation)
      })
    })
  }
  
  get current() {
    return this.globalsStore.getValue()
  }

  private async init() {

    const globals$ = this.helpers.safeUseScullyTransferState(`globals`, from(this.getGlobalsDocument()));

    globals$.subscribe((globals: any) => {
      // console.log('globals', globals)
      this.globalsStore.update({
        en: {
          isEnabled: globals?.en?.isEnabled,
          languageKey: Lang.en,
          footer: {
            firstLine: globals?.en?.footer?.firstLine,
            lastLine: globals?.en?.footer?.lastLine,
          },
          copyright: {
            text: globals?.en?.copyright?.text,
          },
          address: {
            text: globals?.en?.address?.text,
            link: globals?.en?.address?.link,
          },
          application: {
            appStore: {
              link: globals?.en?.application?.appStore?.link,
            },
            googlePlay: {
              link: globals?.en?.application?.googlePlay?.link,
            },
          },
          social: {
            facebook: {
              link: globals?.en?.social?.facebook?.link,
            },
            instagram: {
              link: globals?.en?.social?.instagram?.link,
            },
          }
        },
        hr: {
          isEnabled: globals?.hr?.isEnabled,
          languageKey: Lang.hr,
          footer: {
            firstLine: globals?.hr?.footer?.firstLine,
            lastLine: globals?.hr?.footer?.lastLine,
          },
          copyright: {
            text: globals?.hr?.copyright?.text,
          },
          address: {
            text: globals?.hr?.address?.text,
            link: globals?.hr?.address?.link,
          },
          application: {
            appStore: {
              link: globals?.hr?.application?.appStore?.link,
            },
            googlePlay: {
              link: globals?.hr?.application?.googlePlay?.link,
            },
          },
          social: {
            facebook: {
              link: globals?.hr?.social?.facebook?.link,
            },
            instagram: {
              link: globals?.hr?.social?.instagram?.link,
            },
          }
        }
      })
    })

  }

  /**
   * Get globals document from Flamelink
   * @param key is schema key
   */
   private getGlobalsDocument<T>(): Promise<T> {
    return this.content.get({
      schemaKey: 'globals'
    });
  }


}
